<template>
    <div class="teacher-assignments-container container">
      <el-card shadow="hover" v-if="teacher">
        <template #header>
          <div class="card-header">
            <h2>إدارة إسناد المقررات للمعلم: {{ teacher.name }}</h2>
          </div>
        </template>
  
        <el-tabs v-model="activeTab">
          <el-tab-pane label="المقررات الحالية" name="current">
            <el-table :data="currentAssignments" border style="width: 100%">
              <el-table-column label="المادة الدراسية" prop="course_offering.subject.name" />
              <el-table-column label="الفصل" prop="course_offering.school_class.name" />
              <el-table-column label="الشعبة" prop="section.name" />
              <el-table-column label="إجراء" width="100" align="center">
                <template #default="{ $index }">
                  <el-button type="danger" size="small" @click="removeAssignment($index)">إزالة</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 20px; text-align: left;">
              <el-button type="success" @click="saveAssignments" :loading="isSaving">حفظ كل التغييرات</el-button>
            </div>
          </el-tab-pane>
  
          <el-tab-pane label="إضافة مقرر جديد" name="add">
            <div class="filter-section">
              <el-select v-model="filters.study_year_id" placeholder="اختر السنة الدراسية" @change="onYearChange">
                <el-option v-for="year in studyYears" :key="year.id" :label="year.name" :value="year.id" />
              </el-select>
              <el-select v-model="filters.class_id" placeholder="اختر الفصل" @change="onClassChange" :disabled="!filters.study_year_id">
                <el-option v-for="cls in classes" :key="cls.id" :label="cls.name" :value="cls.id" />
              </el-select>
              <el-select v-model="filters.section_id" placeholder="اختر الشعبة" :disabled="!filters.class_id">
                  <el-option v-for="sec in sections" :key="sec.id" :label="sec.name" :value="sec.id" />
              </el-select>
              <el-button type="primary" @click="fetchAvailableCourses" :disabled="!filters.class_id">بحث عن المقررات</el-button>
            </div>
            
            <el-table :data="availableCourses" v-loading="isLoadingCourses" border style="margin-top: 20px;">
              <el-table-column label="المادة الدراسية" prop="subject.name" />
              <el-table-column label="الفصل" prop="school_class.name" />
              <el-table-column label="الشعبة" prop="section.name" />
              <el-table-column label="إجراء" width="100" align="center">
                <template #default="{ row }">
                  <el-button type="success" size="small" @click="addAssignment(row)">إضافة</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { ElMessage } from 'element-plus';
  
  export default {
    name: 'TeacherAssignments',
    data() {
      return {
        api: null,
        teacher: null,
        activeTab: 'current',
        currentAssignments: [],
        isSaving: false,
        
        filters: { study_year_id: null, class_id: null, section_id: null },
        studyYears: [],
        classes: [],
        sections: [],
        availableCourses: [],
        isLoadingCourses: false,
      };
    },
    created() {
      this.api = axios.create({ baseURL: process.env.VUE_APP_API_BASE_URL || 'https://cale.caledonian.ly/api' });
      this.api.interceptors.request.use((config) => {
        const token = localStorage.getItem('access_token');
        if (token) config.headers['Authorization'] = `Bearer ${token}`;
        return config;
      });
      this.fetchInitialData();
    },
    methods: {
      async fetchInitialData() {
        const teacherId = this.$route.params.user;
        try {
          const [teacherRes, yearsRes] = await Promise.all([
            // ✅ تم التعديل هنا
            this.api.get(`/users-teacher/${teacherId}`),
            this.api.get('/study-years')
          ]);
          
          this.teacher = teacherRes.data;
          this.currentAssignments = this.teacher.teacher_course_assignments || [];
          this.studyYears = yearsRes.data.data || yearsRes.data;
  
        } catch (error) {
          ElMessage.error('فشل في جلب البيانات الأولية.');
        }
      },
      async onYearChange() {
          this.filters.class_id = null;
          this.filters.section_id = null;
          const response = await this.api.get('/classes', { params: { study_year_id: this.filters.study_year_id } });
          this.classes = response.data;
      },
      async onClassChange() {
          this.filters.section_id = null;
          const response = await this.api.get(`/classes/${this.filters.class_id}/sections-for-assign`);
          this.sections = response.data;
      },
      async fetchAvailableCourses() {
          this.isLoadingCourses = true;
          try {
              // ✅ تم التعديل هنا
              const response = await this.api.get('/teacher-course-offerings', { params: this.filters });
              this.availableCourses = response.data;
          } catch(e) {
              ElMessage.error('فشل في جلب المقررات المتاحة.');
          } finally {
              this.isLoadingCourses = false;
          }
      },
      addAssignment(courseOffering) {
        const exists = this.currentAssignments.some(
          (assign) => assign.course_offering_id === courseOffering.id && assign.section_id === courseOffering.section_id
        );
  
        if (exists) {
          ElMessage.warning('هذا المقرر مسند بالفعل لهذا المعلم.');
          return;
        }
        
        this.currentAssignments.push({
            teacher_id: this.teacher.id,
            course_offering_id: courseOffering.id,
            section_id: courseOffering.section_id,
            course_offering: {
                subject: courseOffering.subject,
                school_class: courseOffering.school_class
            },
            section: courseOffering.section
        });
  
        ElMessage.success('تمت إضافة المقرر. اضغط على "حفظ كل التغييرات" لتأكيد الإسناد.');
        this.activeTab = 'current';
      },
      removeAssignment(index) {
          this.currentAssignments.splice(index, 1);
          ElMessage.info('تمت إزالة المقرر. اضغط على "حفظ كل التغييرات" لتأكيد الحذف.');
      },
      async saveAssignments() {
          this.isSaving = true;
          try {
              const payload = {
                  assignments: this.currentAssignments.map(assign => ({
                      course_offering_id: assign.course_offering_id,
                      section_id: assign.section_id,
                  }))
              };
              // ✅ تم التعديل هنا
              await this.api.post(`/teacher-assignments/${this.teacher.id}`, payload);
              ElMessage.success('تم تحديث إسناد المقررات بنجاح!');
          } catch(e) {
              ElMessage.error('فشل في حفظ التغييرات.');
          } finally {
              this.isSaving = false;
          }
      }
    }
  };
  </script>
  
  <style scoped>
  .filter-section {
      display: flex;
      gap: 15px;
      margin-bottom: 20px;
  }
  </style>